import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './ImageLicensePage.module.css';

const ImageLicensePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Image License Info — Brands2Buyers</title>
        <meta property="og:title" content="Image License Info — Brands2Buyers" />
        <meta name="twitter:title" content="Image License Info — Brands2Buyers" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <section className={styles.header}>
        <h1 className={styles.title}>Image License Info</h1>
      </section>

      <section className={styles.content}>
        <div className={styles.container}>
          <p className={styles.text}>
            Toutes les images utilisées sur ce site sont soit la propriété de Brands2Buyers,
            soit utilisées sous licence. Pour toute question concernant les droits d'image,
            veuillez nous contacter à{' '}
            <a href="mailto:hello@brands2buyers.io" className={styles.link}>
              hello@brands2buyers.io
            </a>.
          </p>
        </div>
      </section>
    </>
  );
};

export default ImageLicensePage;
